import ImageGalleryWrapper from "../../components/ImageGallery/ImageGalleryWrapper";

const ImageGallery: React.FC = () => {
  return <ImageGalleryWrapper />;
};

export default ImageGallery;

